module.exports = __webpack_public_path__ + "img/1_001.bc72e3f4.jpg";